module.exports = __webpack_public_path__ + "img/open_row.d41d8cd9.svg";